import { FC, useContext, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import NotificationDispatch, {
  showErrorNotification,
  showSuccessNotification,
} from "../../context/notificationContext";
import useI18n from "../../hooks/useTranslations";
import { useUsersApi } from "../../http/users/api";
import Header from "../ui/Header";
import UserForm, { UserFormBody } from "./UserForm";

const EditUser: FC = () => {
  const usersApi = useUsersApi();
  const { id } = useParams<{ id: string }>();
  const i18n = useI18n();
  const dispatch = useContext(NotificationDispatch);
  const aborter = useRef(new AbortController());

  const { data, trigger } = usersApi.getAdminUser(id!, aborter.current.signal);

  useEffect(() => {
    id && trigger();
  }, [id]);

  const onSubmit = async (formBody: UserFormBody) => {
    try {
      await usersApi.updateAdminUser(id!, {
        permissions: formBody.permissions,
        roles: formBody.roles,
      });
      dispatch(showSuccessNotification(i18n.translation));
    } catch (err) {
      dispatch(showErrorNotification(i18n, err));
    }
  };

  return (
    <>
      <Header title={i18n.translation.users.edit} />
      <UserForm onSubmit={onSubmit} user={data}></UserForm>
    </>
  );
};

export default EditUser;
